import { HttpClient } from '@angular/common/http';
import { LeaderboardParticipantPort } from '../../../domain/leaderboard/ports/leaderboard-participant.port';
import { LeaderboardParticipantHttpAdapter } from '../adapters/leaderboard-participant-http.adapter';
import { LeaderboardParticipantStubAdapter } from '../adapters/leaderboard-participant-stub.adapter';
import { ENVIRONMENT } from '../../../../environments/environment';

export function leaderboardParticipantPortFactory(http: HttpClient): LeaderboardParticipantPort {
  const useHttp = !ENVIRONMENT.mockEnabled && Boolean(ENVIRONMENT.leaderboardEventsApiUrl?.trim());
  return useHttp ? new LeaderboardParticipantHttpAdapter(http) : new LeaderboardParticipantStubAdapter();
}
